export default __webpack_public_path__ + "static/media/mirror_ar 1.f743cd50.png";